import React from 'react';
import language from 'config/es';
import logoCentro from '../../assets/img/centro.png';

/** El año sale del reloj del navegador: no se escribe a mano en ningún sitio. */
const AppFooter = () => (
  <footer className="app-footer">
    <span>
      {language.messages.title_system} © {new Date().getFullYear()}
    </span>
    <span className="app-footer__by">
      <span>Desarrollado por:</span>
      <img src={logoCentro} alt="Centro" className="app-footer__logo" />
    </span>
  </footer>
);

export default AppFooter;
